var map = {
	"./amazon.svg": 854,
	"./archive_org.svg": 855,
	"./arrow-left.svg": 856,
	"./arrow-outline-down.svg": 857,
	"./arrow-right.svg": 858,
	"./bell.svg": 859,
	"./book.svg": 860,
	"./bookshelf.svg": 861,
	"./caret-down.svg": 862,
	"./caret.svg": 863,
	"./chefshat.svg": 864,
	"./chefshat_outlined.svg": 865,
	"./circletick-outline.svg": 866,
	"./circletick-solid.svg": 867,
	"./closed-padlock.svg": 868,
	"./cog.svg": 869,
	"./collections-outline.svg": 870,
	"./collections-solid.svg": 871,
	"./dots.svg": 872,
	"./envelope.svg": 873,
	"./error-outline.svg": 874,
	"./facebook-grey.svg": 875,
	"./facebook.svg": 876,
	"./favourite.svg": 877,
	"./feature-outline.svg": 878,
	"./feature-solid.svg": 879,
	"./filter.svg": 880,
	"./gift.svg": 881,
	"./grid.svg": 882,
	"./help.svg": 883,
	"./home-outline.svg": 884,
	"./home.svg": 885,
	"./info-outline.svg": 886,
	"./instagram-grey.svg": 887,
	"./instagram.svg": 888,
	"./list-add.svg": 889,
	"./list.svg": 890,
	"./magnifier.svg": 891,
	"./native-share.svg": 892,
	"./opened-padlock.svg": 893,
	"./pinterest.svg": 894,
	"./plus.svg": 895,
	"./printer.svg": 896,
	"./push-pin-filled.svg": 897,
	"./push-pin.svg": 898,
	"./restaurant.svg": 899,
	"./search.svg": 900,
	"./tick.svg": 901,
	"./twitter-grey.svg": 902,
	"./twitter.svg": 903,
	"./voice.svg": 904,
	"./x-big.svg": 905,
	"./x.svg": 906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 853;